/**
 * Tracking event type constants
 */
export const NAV = 'nav';
export const PAGE_VIEW = 'pageview';
export const INFO_UPDATE = 'infoupdate';
export const PAGE_UPDATE = 'pageupdate';
export const APP_LAUNCH = 'appinit';
export const START_INFO_UPDATE = 'startinfoupdate';
export const RESTART_INFO_UPDATE = 'restartinfoupdate';
export const APP_INFO_UPDATE = 'appinfoupdate';
export const USER_INFO_UPDATE = 'userinfoupdate';
export const ACTION = 'user_action';
export const BUTTON_CLICK = 'button_click';
export const CLICK = 'click';
export const ELEMENT_VIEW = 'element_in_view';
export const TOGGLE = 'toggle';
export const SWITCH = 'switch';
export const CONSENT_UPDATED = 'consentupdated';
export const TRACK_ACTIVATION = 'trackactivation';
export const TRACK_SUBMENU = 'tracksubmenu';
export const LAUNCH_READY = 'launchready';

/**
 * Grouped tracking event types
 */
export const TrackingType = {
    NAV,
    PAGE_VIEW,
    INFO_UPDATE,
    PAGE_UPDATE,
    APP_LAUNCH,
    START_INFO_UPDATE,
    RESTART_INFO_UPDATE,
    APP_INFO_UPDATE,
    USER_INFO_UPDATE,
    ACTION,
    BUTTON_CLICK,
    CLICK,
    ELEMENT_VIEW,
    TOGGLE,
    SWITCH,
    CONSENT_UPDATED,
    TRACK_ACTIVATION,
    TRACK_SUBMENU,
    LAUNCH_READY,
} as const;

/**
 * Alias for TrackingType — use this when migrating from the legacy TrackEventTypes enum
 */
export const TrackEventTypes = TrackingType;

/**
 * Type union of all valid tracking event types
 */
export type TrackingEventType =
    | typeof NAV
    | typeof PAGE_VIEW
    | typeof INFO_UPDATE
    | typeof PAGE_UPDATE
    | typeof APP_LAUNCH
    | typeof START_INFO_UPDATE
    | typeof RESTART_INFO_UPDATE
    | typeof APP_INFO_UPDATE
    | typeof USER_INFO_UPDATE
    | typeof ACTION
    | typeof BUTTON_CLICK
    | typeof CLICK
    | typeof ELEMENT_VIEW
    | typeof TOGGLE
    | typeof SWITCH
    | typeof CONSENT_UPDATED
    | typeof TRACK_ACTIVATION
    | typeof TRACK_SUBMENU
    | typeof LAUNCH_READY;
